const btn1 = 'Оформить заказ';
const btn2 = 'Рассчитать кредит';


export default {
  CARS: [
    // {
    //   id: "a3",
    //   name: "A3",
    //   full_name: "Audi <span>A3</span>",
    //   filter_name: "A3",
    //   price: 4298000,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "a5_coupe",
    //   name: "A5 Coupé",
    //   full_name: "Audi <span>A5 Coupé</span>",
    //   filter_name: "A5 Coupe",
    //   price: 6490000,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "a5_sportback",
    //   name: "A5 Sportback",
    //   full_name: "Audi <span>A5 Sportback</span>",
    //   filter_name: "A5 Sportback",
    //   price: false,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    {
      id: "q6",
      name: "Q6",
      full_name: "Audi <span>Q6</span>",
      filter_name: "Q6",
      price: 12800000,
      advantage: 1400000,
      dop: 'Автозапуск в <b>подарок</b>',
      trade_in: false,
      price_sup: 1,
      winter_tires: false,
      buttons: [
        {
          type: "red",
          text: "Получить предложение",
        },
        {
          type: "bordered_white",
          text: btn1,
        },
        {
          type: "bordered_white",
          text: btn2,
        },
      ],
      slides: [1, 2, 3, 4],
    },
    {
      id: "q7",
      name: "Q7",
      full_name: "Audi <span>Q7</span>",
      filter_name: "Q7",
      price: 12800000,
      advantage: 1400000,
      dop: 'Автозапуск в <b>подарок</b>',
      trade_in: false,
      price_sup: 1,
      winter_tires: false,
      buttons: [
        {
          type: "red",
          text: "Получить предложение",
        },
        {
          type: "bordered_white",
          text: btn1,
        },
        {
          type: "bordered_white",
          text: btn2,
        },
      ],
      slides: [1, 2, 3, 4],
    },
    {
      id: "q8",
      name: "Q8",
      full_name: "Audi <span>Q8</span>",
      filter_name: "Q8",
      price: 14489000,
      price_sup: 1,
      advantage: 1400000,
      dop: 'Автозапуск в <b>подарок</b>',
      buttons: [
        {
          type: "red",
          text: "Получить предложение",
        },
        {
          type: "bordered_white",
          text: btn1,
        },
        {
          type: "bordered_white",
          text: btn2,
        },
      ],
      slides: [1, 2, 3, 4],
    },
    {
      id: "a6",
      name: "A6",
      full_name: "Audi <span>A6</span>",
      filter_name: "A6",
      price: 5990000,
      trade_in: false,
      /* price_info: 'Audi A6 - от 3 870 000 ₽', */
      price_sup: 1,
      winter_tires: false,
      advantage: 900000,
      dop: 'Автозапуск в <b>подарок</b>',
      buttons: [
        {
          type: "red",
          text: "Получить предложение",
        },
        {
          type: "bordered_white",
          text: btn1,
        },
        {
          type: "bordered_white",
          text: btn2,
        },
      ],
      slides: [1, 2, 3, 4],
    },
    // {
    //   id: "a4",
    //   name: "A4",
    //   full_name: "Audi <span>A4</span>",
    //   filter_name: "A4",
    //   price: 4449000,
    //   price_sup: 1,
    //   winter_tires: false,
    //   dop: 'Автозапуск в <b>подарок</b>',
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn2,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "a7",
    //   name: "A7",
    //   full_name: "Audi <span>A7</span>",
    //   filter_name: "A7",
    //   price: 10889000,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    {
      id: "a8",
      name: "A8",
      full_name: "Audi <span>A8</span>",
      filter_name: "A8",
      price: 15790000,
      price_sup: 1,
      dop: 'Автозапуск в <b>подарок</b>',
      buttons: [
        {
          type: "red",
          text: "Получить предложение",
        },
        {
          type: "bordered_white",
          text: btn1,
        },
        {
          type: "bordered_white",
          text: btn2,
        },
      ],
      slides: [1, 2, 3, 4],
    },
    {
      id: "q3",
      name: "Q3",
      full_name: "Audi <span>Q3</span>",
      filter_name: "Q3",
      price: false,
      price_sup: 1,
      advantage: 800000,
      dop: 'Автозапуск в <b>подарок</b>',
      buttons: [
        {
          type: "red",
          text: "Получить предложение",
        },
        {
          type: "bordered_white",
          text: btn1,
        },
        {
          type: "bordered_white",
          text: btn2,
        },
      ],
      slides: [1, 2, 3, 4],
    },
    // {
    //   id: "q3_sportback",
    //   name: "Q3 Sportback",
    //   full_name: "Audi <span>Q3 Sportback</span>",
    //   filter_name: "Q3 Sportback",
    //   price: false,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    {
      id: "q5",
      name: "Q5",
      full_name: "Audi <span>Q5</span>",
      filter_name: "Q5",
      price: 9498000,
      trade_in: false,
      price_sup: 1,
      winter_tires: false,
      advantage: 800000,
      dop: 'Автозапуск в <b>подарок</b>',
      buttons: [
        {
          type: "red",
          text: "Получить предложение",
        },
        {
          type: "bordered_white",
          text: btn1,
        },
        {
          type: "bordered_white",
          text: btn2,
        },
      ],
      slides: [1, 2, 3, 4],
    },
    {
      id: "q5_sportback",
      name: "Q5 Sportback",
      full_name: "Audi <span>Q5 Sportback</span>",
      filter_name: "Q5 Sportback",
      price: false,
      trade_in: false,
      price_sup: 1,
      advantage: 700000,
      winter_tires: false,
      dop: 'Автозапуск в <b>подарок</b>',
      buttons: [
        {
          type: "red",
          text: "Получить предложение",
        },
        {
          type: "bordered_white",
          text: btn1,
        },
        {
          type: "bordered_white",
          text: btn2,
        },
      ],
      slides: [1, 2, 3, 4],
    },
    // {
    //   id: "S6",
    //   name: "S6",
    //   full_name: "Audi <span>S6</span>",
    //   filter_name: "S6",
    //   price: 14499000,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "S8",
    //   name: "S8",
    //   full_name: "Audi <span>S8</span>",
    //   filter_name: "S8",
    //   price: false,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "S7",
    //   name: "S7",
    //   full_name: "Audi <span>S7 Sportback</span>",
    //   filter_name: "S7 Sportback",
    //   price: false,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "sq7",
    //   name: "SQ7",
    //   full_name: "Audi <span>SQ7</span>",
    //   filter_name: "SQ7",
    //   price: false,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "sq8",
    //   name: "SQ8",
    //   full_name: "Audi <span>SQ8</span>",
    //   filter_name: "SQ8",
    //   price: 23500000,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "e_tron",
    //   name: "e-tron",
    //   full_name: "Audi <span>e-tron</span>",
    //   filter_name: "e-tron",
    //   price: 11990000,
    //   price_sup: 1,
    //   winter_tires: false,
    //   dop: 'Автозапуск в <b>подарок</b>',
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn2,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "e-tron_Sportback",
    //   name: "e-tron Sportback",
    //   full_name: "Audi <span>e-tron Sportback</span>",
    //   filter_name: "e-tron Sportback",
    //   price: false,
    //   price_sup: 1,
    //   winter_tires: false,
    //   dop: 'Автозапуск в <b>подарок</b>',
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn2,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "rs_5_coupe",
    //   name: "RS 5 Coupe",
    //   full_name: "Новый <span>RS 5 Coupe</span>",
    //   filter_name: "RS 5 Coupe",
    //   price: 22900000,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "rs_5_sportback",
    //   name: "RS 5 Sportback",
    //   full_name: "Новый <span>RS 5 Sportback</span>",
    //   filter_name: "RS 5 Sportback",
    //   price: 22900000,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "rs_6_avant",
    //   name: "RS 6 Avant",
    //   full_name: "Новый <span>RS 6 Avant</span>",
    //   filter_name: "RS 6 Avant",
    //   price: 22900000,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "rs_7_Sportback",
    //   name: "RS 7 Sportback",
    //   full_name: "Новый <span>RS 7 Sportback</span>",
    //   filter_name: "RS 7 Sportback",
    //   price: false,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
    // {
    //   id: "rs_q8",
    //   name: "RS Q8",
    //   full_name: "Audi <span>RS Q8</span>",
    //   filter_name: "RS Q8",
    //   price: 23990000,
    //   price_sup: 1,
    //   buttons: [
    //     {
    //       type: "red",
    //       text: "Получить предложение",
    //     },
    //     {
    //       type: "bordered_white",
    //       text: btn1,
    //     },
    //   ],
    //   slides: [1, 2, 3, 4],
    // },
  ],
};
